import merge from 'lodash/merge';

export function categoriesReducer(state = {
  categories: [],
  category: {attributes:{}},

  fetching: false,
  fetched: false,
  saved: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_CATEGORY_LIST_PENDING':
    case 'GET_CATEGORY_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_CATEGORY_LIST_FULFILLED':
    case 'REORDER_CATEGORIES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        categories: action.payLoad.data,
      }
    }
    case 'GET_CATEGORY_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        category: action.payLoad.data,
      }
    }
    case 'GET_CATEGORY_LIST_REJECTED':
    case 'GET_CATEGORY_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'DELETE_CATEGORY_FULFILLED': {
      const newState = {...state};
      newState.categories = newState.categories.filter(category => {
        return category.id !== action.payLoad
      });
      return newState;
    }
    case 'CLEAR_EDIT_CATEGORY': {
      return {
        ...state,
        category: {attributes:{}}
      }
    }
    default:
  }

  return {...state};
}

export function brandsReducer(state = {
  brands: [],
  brand: {attributes:{}},
  editorInput: {},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_BRAND_LIST_PENDING':
    case 'GET_BRAND_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_BRAND_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        brands: action.payLoad.data,
      }
    }
    case 'GET_BRAND_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        brand: action.payLoad.data,
      }
    }
    case 'GET_BRAND_LIST_REJECTED':
    case 'GET_BRAND_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'DELETE_BRAND_FULFILLED': {
      const brands = [...state.brands];
      brands.forEach(category => {
        category.attributes.brands = category.attributes.brands.filter(brand => brand.id !== action.payLoad)
      });
      return {
        ...state,
        brands: brands
      };
    }
    case 'INITIALIZE_ADD_BRAND_FULFILLED': {
      return {
        ...state,
        editorInput: {
          categories: action.payLoad.data,
          statuses: [{label: 'INACTIVE', value: 'INACTIVE'},{label: 'ACTIVE', value: 'ACTIVE'}]
        }
      }
    }
    case 'REORDER_BRANDS_FULFILLED': {
      const brands = [...state.brands];
      const category = brands.find(category => category.id === action.payLoad.categoryId);
      category.attributes.brands = action.payLoad.data;

      return {
        ...state,
        brands: brands
      }
    }
    case 'CLEAR_EDIT_BRAND': {
      return {
        ...state,
        brand: {attributes:{}}
      }
    }
    default:
  }

  return {...state};
}

export function productsReducer(state = {
  products: [],
  product: {},
  newFeaturedProducts: [],
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_PRODUCT_LIST_PENDING':
    case 'GET_PRODUCT_PENDING':
    case 'GET_REPLACEMENT_PRODUCTS_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_PRODUCT_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        products: action.payLoad.data,
      }
    }
    case 'GET_PRODUCT_FULFILLED': {
      if (action.payLoad['all_groups']) {
        action.payLoad['group_ids'] = ['all'];
        action.payLoad['all_groups'] = false;
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        product: action.payLoad,
        saved: false,
      }
    }
    case 'GET_REPLACEMENT_PRODUCTS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        replacementProducts: action.payLoad,
      }
    }
    case 'GET_PRODUCT_LIST_REJECTED':
    case 'SAVE_PRODUCT_REJECTED':
    case 'GET_PRODUCT_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'DELETE_PRODUCT_FULFILLED': {
      const products = [...state.products];
      products.forEach(category => {
        category.attributes.products = category.attributes.products.filter(product => product.id !== action.payLoad)
      });
      return {
        ...state,
        products: products
      }
    }
    case 'REORDER_PRODUCTS_FULFILLED': {
      const products = [...state.products];

      const {brandId: brand, data: reOrderedProducts, categoryId} = action.payLoad;

      const category = products.find(c => c.id === categoryId);
      const categoryIndex = products.indexOf(category);
      const otherProducts = category.attributes.products.filter(p => p.brand_id !== brand);

      products[categoryIndex].attributes.products = merge(otherProducts, reOrderedProducts);

      return {
        ...state,
        products: products
      }
    }
    case 'SAVE_PRODUCT_FULFILLED': {
      return {
        ...state,
        saved: true,
      }
    }
    case 'CLEAR_EDIT_PRODUCT': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        product: {},
      }
    }
    default:
  }

  return {...state};
}

export function groupSelectorReducer(state = {
  groups: [],
  fetching: false,
  fetched: false,
  saved: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_GROUPS_LIST_PENDING': {
      return { ...state, fetching: true, fetched: false }
    }
    case 'GET_GROUPS_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        groups: action.payLoad.groups,
      }
    }
    case 'GET_GROUPS_LIST_REJECTED': {
      return { ...state, errors: action.payLoad.errors }
    }
    default:
  }

  return { ...state };
}



// WEBPACK FOOTER //
// ./src/reducers/productsReducer.js